import { render, staticRenderFns } from "./classPush.vue?vue&type=template&id=9cf908c6&scoped=true"
import script from "./classPush.vue?vue&type=script&lang=js"
export * from "./classPush.vue?vue&type=script&lang=js"
import style0 from "./classPush.vue?vue&type=style&index=0&id=9cf908c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf908c6",
  null
  
)

export default component.exports